module.exports = __webpack_public_path__ + "img/valores.0fbe4d45.png";